import { useSelector } from "@/store";

export function useBalance() {
  const { balance } = useSelector((store) => store.auth);

  return balance;
}
